function splitPath(path: string): string[] {
	return path
		.split("/")
		.filter(Boolean)
		.map((segment) => {
			try {
				return decodeURIComponent(segment);
			} catch {
				return segment;
			}
		});
}

export function matchesPathTemplate(
	template: string,
	pathname: string,
): boolean {
	const templateSegments = splitPath(template);
	const pathnameSegments = splitPath(pathname);
	return (
		templateSegments.length === pathnameSegments.length &&
		templateSegments.every(
			(segment, index) =>
				(segment.startsWith("{") && segment.endsWith("}")) ||
				segment === pathnameSegments[index],
		)
	);
}
